export default {
  name: 'packages',
  translationKey: 'packages-module',
  routePrefix: 'packages',
  routeNamePrefix: 'admin.packages',
  directRoutesAvailable: false,
}
